module.exports = __webpack_public_path__ + "static/media/message-received.e2e956ce.mp3";